module.exports = require('./lib/immutable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/immutable.js
 ** module id = 71
 ** module chunks = 0
 **/